import { connect } from 'react-redux';

import ChooseCover from '~/Components/Pages/ChooseCover/ChooseCover';

import { getSkins } from '~/Redux/Modules/Products';
import { updateSkin } from '~/Redux/Modules/UserOptions';

import { SKINS } from '~/Config/Products';

const mapStateToProps = ({ Products, UserOptions }) => {
  return {
    skins: Products[SKINS],
    userOptions: UserOptions.data,
    isFetching: UserOptions.isFetching,
    fetched: UserOptions.fetched,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    getSkins: () => dispatch(getSkins()),
    updateSkin: (id, skinId, cover) => dispatch(updateSkin(id, skinId, cover)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ChooseCover);
